<template>
  <div class="top" @click="gotologin">
    <img class="img" src="../../assets/mobileImgs/logo9.svg" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    gotologin(){
           this.$router.push({ path: "/login" });
    },
  },
};
</script>
<style lang="scss" scoped>
.login-bg .top {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #4bacc2;
}
.login-bg .top img {
  width: 204px;
  height: 32px;
  margin: 15px 0 0 20px;
}
.top {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #d63630;
}
.img {
  width: 204px;
  height: 32px;
  margin: 15px 0 0 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobileComponents/header.vue